import tns from "@/lib/tiny-slider/tiny-slider.js";

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.gallery').forEach(function (gallery) {
        var containerEl = gallery.querySelector('.gallery-slider');
        if (!containerEl) return;

        var slider = tns({
            container: containerEl,
            items: 1,
            slideBy: 1,
            nav: false,
            controls: false,
            autoplay: false,
            speed: 300
        });

        var prev = gallery.querySelector('.left-arrow') || gallery.querySelector('.slick-prev');
        var next = gallery.querySelector('.right-arrow') || gallery.querySelector('.slick-next');

        if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); slider.goTo('prev'); });
        if (next) next.addEventListener('click', function (e) { e.preventDefault(); slider.goTo('next'); });
    });
});


